import { render, staticRenderFns } from "./VgHeading.vue?vue&type=template&id=fec365b0&scoped=true&"
import script from "./VgHeading.vue?vue&type=script&lang=js&"
export * from "./VgHeading.vue?vue&type=script&lang=js&"
import style0 from "./VgHeading.vue?vue&type=style&index=0&id=fec365b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec365b0",
  null
  
)

export default component.exports